export default {
	countries: '/countries',
	offers: '/offers',
};
